export default {
  Title: 'Tickets',
  Domain: 'Domain',
  Source: 'Source',
  CreatedOn: 'Created on',
  Status: 'Status',
  NeedApprove: 'Need approval',
  Rejected: 'Rejected',
  View: 'View',
  Country: 'Country',
  Search: 'Search',
  Total: 'Total: {number} requests',
  OtherReason: 'Other reason',
};
